import * as React from 'react';
import Project from 'src/entities/Project';
import InvestmentFunnelHeaderComponent from './partials/InvestmentFunnelHeader.component';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import Investment from 'src/entities/Investment';
import '../Modals.css';
import NumberFormater from 'src/services/number-formater/NumberFormater.service';

export interface AcceptsCommitmentInvestmentComponentProps {
  project: Project;
  modalRef?: Modal;
  investment: Investment;
  next: () => void;
}

class AcceptsCommitmentInvestmentComponent extends React.PureComponent<AcceptsCommitmentInvestmentComponentProps> {

  public render(): React.ReactNode {
    const totalValue = NumberFormater
      .euros(this.props.investment.quantityTickets * this.props.project.ticketValue * (1.0 + 0.02 * 1.21));

    return (
      <div className="modal-content investment-funnel-modal">
        <InvestmentFunnelHeaderComponent
          logo={this.props.project.company.logo}
          modalRef={this.props.modalRef}
        />
        <div className="modal-body">
          <h6 className="f-s-18">
            Recuerda:
          </h6>
          <div className="gap-20" />
          <p>
            Con esta acción, te estás&nbsp;
            <strong>
              comprometiendo contractualmente de forma irrevocable
              &nbsp;
            </strong>
            a llevar a cabo una inversión de&nbsp;
            <strong className="f-s-18 italic">
              {totalValue}&nbsp;
            </strong>
            en la empresa&nbsp;
            {this.props.project.company.name}
            .
          </p>
          <div className="gap-20" />
          <p>
            ¿Aceptas el compromiso?
          </p>
          <div className="gap-20" />
          <button
            type="button"
            className="btn btn-secondary btn-lg w-100"
            onClick={this.props.next}
          >
            Acepto el compromiso
          </button>
          <div className="gap-20" />
        </div>
      </div>
    );
  }
}

export default AcceptsCommitmentInvestmentComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/AcceptsCommitmentInvestment.component.tsx